import React from 'react'
import PropTypes from 'prop-types'
import './Characters.styles.css'

export default function CharactersToolbar({ search, onSearchChange, sort, onSortChange }) {
  return (
    <div className="charactersToolbar" role="region" aria-label="Buscar y ordenar ninjas">
      <input
        type="text"
        placeholder="Buscar por nombre, clan o rango"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        aria-label="Buscar por nombre, clan o rango"
      />
      <select value={sort} onChange={(e) => onSortChange(e.target.value)} aria-label="Ordenar">
        <option value="recent">Más recientes</option>
        <option value="alpha">Alfabético</option>
        <option value="favorite">Principal primero</option>
      </select>
    </div>
  )
}

CharactersToolbar.propTypes = {
  search: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  sort: PropTypes.oneOf(['recent', 'alpha', 'favorite']).isRequired,
  onSortChange: PropTypes.func.isRequired,
}
